/**
 * @generated SignedSource<<373c332ca5a43d7a2d16ee7cec3cbda6>>
 * @relayHash 14e5a988e61fa67579bfc9b50b93870d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0e58823bd142c5ef352c216e453ac1dff672a243ee6303171aa797a69ff103ee

import type { ConcreteRequest } from 'relay-runtime';
export type useCreatePersonalSpaceGetPublicNameQuery$variables = {
  accountId: string;
};
export type useCreatePersonalSpaceGetPublicNameQuery$data = {
  readonly confluenceUsers: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "KnownUser";
      readonly __typename: "KnownUser";
      readonly publicName: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null> | null;
  } | null;
};
export type useCreatePersonalSpaceGetPublicNameQuery = {
  response: useCreatePersonalSpaceGetPublicNameQuery$data;
  variables: useCreatePersonalSpaceGetPublicNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "accountIds.0",
            "variableName": "accountId"
          }
        ],
        "kind": "ListValue",
        "name": "accountIds"
      }
    ],
    "concreteType": "PaginatedPersonList",
    "kind": "LinkedField",
    "name": "confluenceUsers",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "publicName"
              }
            ],
            "type": "KnownUser"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreatePersonalSpaceGetPublicNameQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreatePersonalSpaceGetPublicNameQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "14e5a988e61fa67579bfc9b50b93870d",
    "id": "0e58823bd142c5ef352c216e453ac1dff672a243ee6303171aa797a69ff103ee",
    "metadata": {},
    "name": "useCreatePersonalSpaceGetPublicNameQuery",
    "operationKind": "query",
    "text": "query useCreatePersonalSpaceGetPublicNameQuery($accountId:String!){confluenceUsers(accountIds:[$accountId]){nodes{__typename,...on KnownUser{__typename,publicName}}}}"
  }
};
})();

(node as any).hash = "6eaa36d7e7d2eafc735855845cb44bed";

export default node;
